import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserType } from '../../../../../../shared/schemas/userSchema';
import { addUserToStore } from '../../../store/slices/usersSlice/usersSlice.actions';
import { selectAllUsers } from '../../../store/slices/usersSlice/usersSlice.selector';
import { AppStore } from '../../../store/store';
import { UsersService } from '../services/users.service';
import labels from './../data/balance-table.json';

@Component({
  selector: 'app-balance-table',
  templateUrl: './balance-table.component.html',
  styleUrl: './balance-table.component.scss',
})
export class BalanceTableComponent implements OnInit, OnDestroy {
  data: Observable<UserType[]> = this.store.select(selectAllUsers);
  displayedColumns: string[] = ['firstName', 'balance'];
  header: string = labels.header;

  private destroy$ = new Subject<void>();

  constructor(
    private store: Store<AppStore>,
    private usersService: UsersService,
  ) {}

  ngOnInit(): void {
    this.usersService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (users) =>
          users.forEach((user) => this.store.dispatch(addUserToStore({ user }))),
        error: (err) => console.error('Error fetching users:', err),
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
